// extracted by mini-css-extract-plugin
export default {"wrapper":"SocialAuth_wrapper__A6aGU","button":"SocialAuth_button__X0hf7","google":"SocialAuth_google__d5-4M","facebook":"SocialAuth_facebook__qEGzC"};